import React, { useContext, FC } from 'react';

import { makeStyles, Box } from '@material-ui/core';

import { ReactComponent as IAMLogo } from 'src/images/iam_logo.svg';

import { useHistory, useLocation } from 'react-router';
import { AuthContext, AuthStatus } from 'src/contexts/authContext';
import { colors } from 'src/constants/theme/colors';
import { transitions } from 'src/constants/theme/transitions';
import GuestHeader from './GuestHeader';
import Account from '../Account';

const useStyles = makeStyles(() => ({
  wrapper: {
    padding: '0 16px 0 80px',
    width: '100%',
    transition: transitions.default,
    minWidth: 600,
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: colors.background.primary,
    zIndex: 3,
    borderBottom: `1px solid ${colors.border.default}`
  },
  openWrapper: {
    marginLeft: 185,
    padding: '0 16px 0px 32px',
    width: 'calc(100% - 185px)',
    transition: transitions.default,
    minWidth: 600,
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: colors.background.primary,
    zIndex: 99,
    borderBottom: `1px solid ${colors.border.default}`
  },
  topBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: {
    fontFamily: 'Poppins',
    color: colors.text.primary,
    fontSize: 26,
    fontWeight: 600
  },
  subTitle: {
    fontFamily: 'Poppins',
    color: colors.text.tertiary,
    fontSize: 16,
    fontWeight: 400
  },

  hr: {
    height: 1,
    border: 0,
    backgroundColor: colors.border.default
  },

  logo: {
    width: 64,
    height: 24,
    cursor: 'pointer'
  }
}));

const UiHeader: FC<{
  visible: boolean;
  expireDate: any;
  exportedCount: number;
}> = ({ visible, expireDate, exportedCount }) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  // const [guestMode, setGuestMode] = useState(false);
  const { authStatus } = useContext(AuthContext);
  const isGuest =
    authStatus !== AuthStatus.SignedIn &&
    location.pathname === '/workspace/templates';

  const onClickLogo = () => {
    history.push('/workspace/draft');
  };
  const onClickLogoGuest = () => {
    window.location.href = 'https://www.inappmessage.com';
  };

  // useEffect(() => {
  //   if (
  //     authStatus !== AuthStatus.SignedIn &&
  //     location.pathname === '/workspace/templates'
  //   ) {
  //     setGuestMode(true);
  //   } else {
  //     setGuestMode(false);
  //   }
  // }, [authStatus]);

  return (
    <Box className={visible ? classes.openWrapper : classes.wrapper}>
      <Box className={classes.topBar}>
        {isGuest ? (
          <GuestHeader
            onClickLogoGuest={onClickLogoGuest}
            style={{ background: 'none', color: 'black' }}
            isBlack={false}
          />
        ) : (
          <>
            <Box>
              <IAMLogo className={classes.logo} onClick={onClickLogo} />
            </Box>
            <Account expireDate={expireDate} exportedCount={exportedCount} />
          </>
        )}
      </Box>
    </Box>
  );
};

export default UiHeader;
